import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View, type ViewProps } from 'react-native';
import { theme } from '@garnish/constants';
import { DisplayText, useResponsive } from '@sg/garnish';

import { LoyaltyIconSgReward } from '../../LoyaltyIconSgReward';
import { LoyaltyTerms } from '../../LoyaltyTerms';

export const LoyaltyHomeFooter = (props: LoyaltyHomeFooterProps) => {
  const { termsAndConditionsUrl, style } = props;

  const { currentBreakpoint, match } = useResponsive();
  const containerStyle = [
    match([styles.containerXS, styles.containerSM]),
    style,
  ];

  return (
    <View style={containerStyle}>
      <View style={match([styles.wrapperXS, styles.wrapperSM])}>
        {currentBreakpoint.isXS ? (
          <LoyaltyTerms termsAndConditionsUrl={termsAndConditionsUrl} />
        ) : (
          <RewardsTitle />
        )}

        {currentBreakpoint.isXS ? (
          <RewardsTitle />
        ) : (
          <LoyaltyTerms termsAndConditionsUrl={termsAndConditionsUrl} />
        )}
      </View>
    </View>
  );
};

const RewardsTitle = () => {
  const { match } = useResponsive();

  return (
    <View style={match([styles.rewardsTitleXS, styles.rewardsTitleSM])}>
      <LoyaltyIconSgReward scale={match([2, 3])} palette="white-outline" />

      <DisplayText style={styles.label} sizeMatch={['48', '48']}>
        <FormattedMessage {...messages.rewards} />
      </DisplayText>
    </View>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  rewards: {
    defaultMessage: 'rewards',
    description: 'Loyalty Home | Footer | Title',
  },
});

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    flexGrow: 1,
    backgroundColor: theme.colors.FOREST,
    gap: theme.spacing['10'],
    paddingTop: theme.spacing['4'],
    paddingBottom: theme.spacing['25'],
    paddingHorizontal: theme.spacing['10'],
  },
  containerSM: {
    flexGrow: 1,
    backgroundColor: theme.colors.FOREST,
    gap: theme.spacing['10'],
    paddingTop: theme.spacing['16'],
    paddingBottom: theme.spacing['25'],
    paddingHorizontal: theme.spacing['30'],
  },
  wrapperXS: {
    marginTop: 'auto',
    alignItems: 'center',
    gap: theme.spacing['6'],
  },
  wrapperSM: {
    marginTop: 'auto',
    alignItems: 'center',
    gap: theme.spacing['12'],
  },
  rewardsTitleXS: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing['8'],
  },
  rewardsTitleSM: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing['12'],
  },
  label: {
    color: theme.colors.CREAM,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LoyaltyHomeFooterProps = {
  termsAndConditionsUrl: string;
  style: ViewProps['style'];
};
